import axios from "./axios";

export const chemicalInventoryApi = {
  // Get all chemical inventories with filters
  getChemicalInventories: async (params = {}) => {
    return axios
      .get("/chemical_inventories", {
        params,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Get a single chemical inventory by ID
  getChemicalInventory: async (id) => {
    return axios
      .get(`/chemical_inventories/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Create a new chemical inventory
  createChemicalInventory: async (data) => {
    return axios
      .post("/chemical_inventories", {
        chemical_inventory: data,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Update an existing chemical inventory
  updateChemicalInventory: async (id, data) => {
    return axios
      .put(`/chemical_inventories/${id}`, {
        chemical_inventory: data,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Delete a chemical inventory
  deleteChemicalInventory: async (id) => {
    return axios
      .delete(`/chemical_inventories/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Create chemical inventory from product
  createFromProduct: async (productId) => {
    return axios
      .post(`/chemical_inventories/${productId}/create_from_product`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Add document to chemical inventory
  addDocument: async (id, documentData) => {
    return axios
      .post(`/chemical_inventories/${id}/add_document`, documentData)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Remove document from chemical inventory
  removeDocument: async (id, documentId) => {
    return axios
      .delete(`/chemical_inventories/${id}/remove_document`, {
        data: { document_id: documentId },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Add note to chemical inventory
  addNote: async (id, noteData) => {
    return axios
      .post(`/chemical_inventories/${id}/add_note`, noteData)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  // Get statistics
  getStatistics: async () => {
    return axios
      .get("/chemical_inventories/statistics")
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
};
